import { useLocalSearchParams } from 'expo-router';

import { useViewEvents } from '../../events/hooks/useViewEvents';
import CalendlySession from './CalendlySession';

const RescheduleSession = () => {
    const { trackViewOnce } = useViewEvents();

    const { rescheduleUrl, doneRoute } = useLocalSearchParams<{
        rescheduleUrl?: string;
        doneRoute?: string;
    }>();

    trackViewOnce('GuidanceSessions/RescheduleSession');

    return (
        <CalendlySession
            headerText="Find a date that works for you"
            calendlyUrl={rescheduleUrl}
            doneRoute={doneRoute}
        />
    );
};

export default RescheduleSession;
